import {
  createUnifiedTheme,
  palettes,
  genPageTheme,
  shapes,
} from '@backstage/theme';

export const mouraTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: {
      main: '#003399', // Azul Moura
    },
    secondary: {
      main: '#FFCC00', // Amarelo Moura
    },
    navigation: {
      background: '#002878',
      indicator: '#FFCC00',
      color: '#FFFFFF',
      selectedColor: '#FFCC00',
    },
  },
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#003399', '#002878'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#003399', '#002878'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#003399', '#002878'], shape: shapes.wave }),
    components: genPageTheme({ colors: ['#003399', '#002878'], shape: shapes.wave }),
    stats: genPageTheme({ colors: ['#003399', '#002878'], shape: shapes.wave }),
    tool: genPageTheme({ colors: ['#003399', '#002878'], shape: shapes.wave }),
  },
});
